import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ILocationHardwareCompanyOwnedItem } from '~/types/location/models'

const apiEntityPath = '/api/locationhardwarecompanyowneditems'

export async function getLocationHardwareCompanyOwnedItemsForLocation(
  id: string
) {
  const callingMn = getLocationHardwareCompanyOwnedItemsForLocation.name
  const apiPath = `${apiEntityPath}/${id}`
  return httpGet<ILocationHardwareCompanyOwnedItem[]>({ callingMn, apiPath })
}

export async function createLocationHardwareCompanyOwnedItem(
  entity: ILocationHardwareCompanyOwnedItem
) {
  const callingMn = createLocationHardwareCompanyOwnedItem.name
  const apiPath = apiEntityPath
  return httpPost<ILocationHardwareCompanyOwnedItem>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateLocationHardwareCompanyOwnedItem(
  entityData: Partial<ILocationHardwareCompanyOwnedItem>,
  id: TEntityId
) {
  const callingMn = updateLocationHardwareCompanyOwnedItem.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialILocationHardwareCompanyOwnedItem =
    Partial<ILocationHardwareCompanyOwnedItem>
  return httpPatchMerge<TPartialILocationHardwareCompanyOwnedItem>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteLocationHardwareCompanyOwnedItem(
  entityData: ILocationHardwareCompanyOwnedItem
) {
  const callingMn = deleteLocationHardwareCompanyOwnedItem.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
